export default "__VITE_ASSET__DXj0Hxwp__"